import IncomeUnitType from "../../../types/unit/IncomeUnit";
import { GET_TENANT_SUMMARY_BY_SNAPSHOT_ID, RESET_GET_TENANT_SUMMARY_BY_SNAPSHOT_ID } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface GetTenantSummaryState extends BaseAsyncReducerState {
    snapshotId: "",
    tenantSummary: IncomeUnitType[];
}

// Define an initial state value for the app
const initialState: GetTenantSummaryState = {
    loading: false,
    error: false,
    success: false,
    snapshotId: "",
    tenantSummary: []
}

function getTenantSummaryReducer(state = initialState, action: AppAction | LocalAction) {

    switch (action.type) {
        case GET_TENANT_SUMMARY_BY_SNAPSHOT_ID.PENDING:
            return {
                loading: true,
                error: false,
                success: false,
            }

        case GET_TENANT_SUMMARY_BY_SNAPSHOT_ID.SUCCESS:
            return {
                ...state,
                success: (action as AppAction).payload.success,
                snapshotId: ((action as AppAction).payload as Record<string, unknown>)["snapshotId"],
                tenantSummary: (action as AppAction).payload.data,
                status: (action as AppAction).payload.status,
                loading: false,
                error: false,
            }

        case GET_TENANT_SUMMARY_BY_SNAPSHOT_ID.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                success: false,
            }

        case RESET_GET_TENANT_SUMMARY_BY_SNAPSHOT_ID:
            return {
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default getTenantSummaryReducer;